/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

/** Common Components */
import Buttons from "../ui/button/Buttons";
import DropdownSelect from "../ui/dropdown/DropdownSelect";
import TextArea from "../finalForms/ui/inputs/textArea/TextArea";
import DatePickerComponent from "../finalForms/ui/inputs/datePicker/DatePicker";

/** Common Services & Data Files */
import formatDate from "../../lib/formatDate";
import Label from "../../components/ui/label/Label";
import SwalAlert from "../../services/swalService/SwalService";

/** Configuration Files */
import ToastService from "../../services/toastService/ToastService";

/** RTK Query */
import { useAddTimeSheetRecordMutation } from "../../app/services/timeSheetLogAPI";
import { useLazyGetAssignProjectListByUserIdQuery } from "../../app/services/projectManagementAPI";
import { useGetProjectStatusWithPaginationMutation } from "../../app/services/projectStatusAPI";
import {
  useGetAllTimeLogSubActivityMutation,
  useLazyGetAllTimeLogActivityQuery,
} from "../../app/services/commonAPI";
import { useGetMyTaskListByProjectIdMutation } from "../../app/services/taskAPI";
import Iconify from "../../layouts/components/iconify/iconify";
import Input from "../ui/inputs/input/Input";

const TimeLogPopup = (props) => {

  const UserId = useSelector((item) => item.auth.user.userId);
  const [timesheetId, setTimesheetId] = useState();
  const [projectList, setProjectList] = useState([]);
  const [selectProject, setSelectProject] = useState(null);
  const [activityList, setActivityList] = useState([]);
  const [selectActivity, setSelectActivity] = useState(null);
  const [subActivityList, setSubActivityList] = useState([]);
  const [selectSubActivity, setSelectSubActivity] = useState(null);
  const [taskList, setTaskList] = useState([]);
  const [selectTask, setSelectTask] = useState(null);
  // const [taskStatusList, setTaskStatusList] = useState([]);
  const [selectTaskstatus, setSelectTaskstatus] = useState(null);
  const [startTimeData, setStartTimeData] = useState(new Date());
  const [workAtData, setWorkAtData] = useState(new Date());
  const [endTimeData, setEndTimeData] = useState();
  const [desciptionData, setDesciptionData] = useState();
  const [totalTime, setTotalTime] = useState("");
  const userId = useSelector((state) => state.auth.user.userId);

  const { error } = SwalAlert();

  const filterPassedTime = (time) => {
    if (!startTimeData) return true;
    const currentDate = new Date(startTimeData);
    const selectedDate = new Date(time);

    return currentDate.getTime() <= selectedDate.getTime();
  };

  const [
    getAllTimeLogActivity,
    {
      isFetching: isActivityFetching,
      isSuccess: isActivityFetched,
      data: timeLogActivityData,
    },
  ] = useLazyGetAllTimeLogActivityQuery();

  const [
    getAllTimeSubLogActivity,
    {
      isFetching: isSubActivityFetching,
      isSuccess: isSubActivityFetched,
      data: timeLogSubActivityData,
    },
  ] = useGetAllTimeLogSubActivityMutation();

  const [
    getAllTaskStatus,
    {
      isFetching: isTaskStatusfetching,
      isSuccess: isTaskStatussuccess,
      data: isTaskStatusData,
    },
  ] = useGetProjectStatusWithPaginationMutation();

  const [
    getMyTaskByProjectId,
    {
      isFetching: isMyTaskByProjectIdFetching,
      isSuccess: isMyTaskByProjectIdSuccess,
      data: myTaskByProjectIdData,
    },
  ] = useGetMyTaskListByProjectIdMutation();

  // const [
  //   getAllProjects,
  //   {
  //     isFetching: isProjectFetching,
  //     isSuccess: isProjectFetched,
  //     data: allProjectData,
  //   },
  // ] = useLazyGetAllProjectsQuery();

  const [
    addTimeSheetRecord,
    {
      isLoading: isTimeSheetRecordAdding,
      isSuccess: isTimeSheetRecordAdded,
      data: addTimeSheetRecordData,
    },
  ] = useAddTimeSheetRecordMutation();

  const [getAssignProjectListByUserId, {
    isSuccess: isListSuccess,
    data: ProjectList
  },] = useLazyGetAssignProjectListByUserIdQuery();

  const handleSaveClick = () => {
    if (
      !selectSubActivity ||
      !selectSubActivity.value ||
      !selectActivity ||
      !selectActivity?.value ||
      !workAtData ||
      !startTimeData ||
      !endTimeData ||
      !desciptionData ||
      (selectActivity.value === 1 && selectActivity.value === 6 && (!selectProject || !selectTask))
    ) {
      error("Please fill all the required fields.", "Validation Failed!");
      return;
    }
    const startTime = formatDate(startTimeData, "HH:mm:ss");
    const endTime = formatDate(endTimeData, "HH:mm:ss");

    if (startTime >= endTime) {
      error("Start time must be earlier than end time.", "Invalid Time Range!");
      return;
    }

    const req = {
      timesheetDetailId: props?.slotInfo?.timesheetDetailId || 0,
      timesheetId: timesheetId,
      userId: UserId,
      projectId: (selectActivity.value === 1 || selectActivity.value === 6 ? selectProject.value : null),
      taskId: (selectActivity.value === 1 ? selectTask.value : null),
      taskStatusId: selectTaskstatus ? selectTaskstatus.value : null,
      timeLogActivityId: selectActivity.value,
      timeLogSubActivityId: selectSubActivity.value,
      startTime: startTime,
      endTime: endTime,
      WorkDescription: desciptionData,
      workAt: workAtData,
    };

    addTimeSheetRecord(req);
  };

  useEffect(() => {
    if (props.isOpen && props.slotInfo) {
      setTimesheetId(props.slotInfo.timesheetId);
      setSelectProject(props.slotInfo.projectId);
      getMyTaskByProjectId({
        projectId: props.slotInfo.projectId || 0,
        userId: UserId,
        CurrentDate: new Date(),
      });
      setSelectTask(props.slotInfo.taskId);
      getAllTimeSubLogActivity({
        timeLogActivityId: props.slotInfo.timeLogActivityId,
      });
      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 100,
        },
        projectId: props.slotInfo.projectId || 146,
      };
      getAllTaskStatus(request);
      setDesciptionData(props.slotInfo.workDescription);
      const dateTimeString = `1970-01-01T${props.slotInfo.startTime}`;
      const datestartTime = new Date(dateTimeString);
      setStartTimeData(datestartTime);
      const dateTimeString1 = `1970-01-01T${props.slotInfo.endTime}`;
      const dateendTime = new Date(dateTimeString1);
      setEndTimeData(dateendTime);
      setWorkAtData(props.slotInfo.workAt);
    }
  }, [props.isOpen, props.slotInfo]);

  const handalactivity = (options) => {
    setSelectActivity(options);
    setSelectSubActivity(null);
    if (options) {
      getAllTimeSubLogActivity({ timeLogActivityId: options.value });
    }
    if (timeLogSubActivityData) {
      const subActivityListData = timeLogSubActivityData.map((item) => ({
        value: item.timeLogSubActivityId,
        label: item.subActivityName,
      }));
      setSubActivityList(subActivityListData);
    }
  };

  const handalprojectchange = (options) => {
    setSelectProject(options);
    setSelectTask(null);
    setSelectTaskstatus(null);
    if (options) {
      getMyTaskByProjectId({
        projectId: options.value,
        userId: UserId,
        CurrentDate: new Date(),
      });

      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 100,
        },
        filters: {
          searchText: "",
        },
        projectId: options.value,
      };
      getAllTaskStatus(request);
    }
    if (myTaskByProjectIdData) {
      const taskListData = myTaskByProjectIdData.map((item) => ({
        value: item.taskId,
        label: item.title,
      }));
      setTaskList(taskListData);
    }
    // if (isTaskStatusData) {
    //   const taskStatusListData = isTaskStatusData.dataSource.map((item) => ({
    //     value: item.projectStatusConfigurationId,
    //     label: item.statusName,
    //   }));
    //   // setTaskStatusList(taskStatusListData);
    // }
  };

  const handleCloseClick = () => {
    if (props.onClose) {
      props.onClose();
      setSelectProject(null);
      setSelectActivity(null);
      setSelectSubActivity(null);
      setSelectTask(null);
      setSelectTaskstatus(null);
      setWorkAtData(new Date());
      setDesciptionData();
      setEndTimeData();
    }
  };
  // initial API calls
  useEffect(() => {
    if (props.isOpen) {
      // getAllProjects();
      getAllTimeLogActivity();
      if (userId) {
        getAssignProjectListByUserId(userId);
      }
    }
  }, [props.isOpen]);

  useEffect(() => {
    if (props.isModelOpen) {
      // getAllProjects();
      getAllTimeLogActivity();
      getMyTaskByProjectId({
        projectId: props.dataObj.projectId,
        userId: UserId,
        CurrentDate: new Date(),
      });

      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 100,
        },
        projectId: props.dataObj.projectId,
      };
      getAllTaskStatus(request);
    }
  }, [props.isModelOpen]);

  useEffect(() => {
    if (isListSuccess && ProjectList) {
      const projectListData = ProjectList.map((item) => ({
        value: item.projectId,
        label: item.projectName
      }));
      setProjectList(projectListData);

      if (props.slotInfo) {
        const selectedProject = projectListData.find(
          (project) => project.value === props.slotInfo.projectId
        );
        setSelectProject(selectedProject || null);
      }
      if (props.isModelOpen) {
        const selectedProject = projectListData.find(
          (project) => project.value === props.dataObj.projectId
        );
        setSelectProject(selectedProject || null);
      }
    }
  }, [isListSuccess, ProjectList]);


  // useEffect(() => {
  //   if (!isProjectFetching && isProjectFetched && allProjectData) {
  //     const projectListData = allProjectData.map((item) => ({
  //       value: item.projectId,
  //       label: item.projectName,
  //     }));
  //     setProjectList(projectListData);

  //     if (props.slotInfo) {
  //       const selectedProject = projectListData.find(
  //         (project) => project.value === props.slotInfo.projectId
  //       );
  //       setSelectProject(selectedProject || null);
  //     }
  //     if (props.isModelOpen) {
  //       const selectedProject = projectListData.find(
  //         (project) => project.value === props.dataObj.projectId
  //       );
  //       setSelectProject(selectedProject || null);
  //     }
  //   }
  // }, [isProjectFetching, isProjectFetched, allProjectData, props.slotInfo]);

  // Task Dropdown
  useEffect(() => {
    if (
      !isMyTaskByProjectIdFetching &&
      isMyTaskByProjectIdSuccess &&
      myTaskByProjectIdData
    ) {
      const taskListData = myTaskByProjectIdData.map((item) => ({
        value: item.taskId,
        label: item.title,
      }));
      setTaskList(taskListData);
      if (props.slotInfo) {
        const selectedTask = taskListData.find(
          (task) => task.value === props.slotInfo.taskId
        );
        setSelectTask(selectedTask);
      }
      if (props.isModelOpen) {
        const selectedTask = taskListData.find(
          (task) => task.value === props.dataObj.taskId
        );
        setSelectTask(selectedTask);
      }
    }
  }, [
    isMyTaskByProjectIdFetching,
    isMyTaskByProjectIdSuccess,
    myTaskByProjectIdData,
    props.slotInfo,
  ]);

  // Status Dropdown
  useEffect(() => {
    if (!isTaskStatusfetching && isTaskStatussuccess && isTaskStatusData) {
      const taskStatusListData = isTaskStatusData.dataSource.map((item) => ({
        value: item.projectStatusConfigurationId,
        label: item.statusName,
      }));
      // setTaskStatusList(taskStatusListData);
      if (props.slotInfo) {
        const selectedTaskStatus = taskStatusListData.find(
          (status) => status.statusName === props.slotInfo.statusName
        );
        setSelectTaskstatus(selectedTaskStatus || null);
      }
      if (props.isModelOpen) {
        const selectedTaskStatus = taskStatusListData.find(
          (status) => status.label === props.dataObj.statusName
        );
        setSelectTaskstatus(selectedTaskStatus || null);
      }
    }
  }, [
    isTaskStatusfetching,
    isTaskStatussuccess,
    isTaskStatusData,
    props.slotInfo,
    props.isModelOpen,
  ]);

  // Activity Dropdown
  useEffect(() => {
    if (!isActivityFetching && isActivityFetched && timeLogActivityData) {
      const activityListData = timeLogActivityData.map((item) => ({
        value: item.timeLogActivityId,
        label: item.activityName,
      }));
      const filterData = activityListData.filter((i) => i.value !== 3)

      setActivityList(filterData);
      if (props.slotInfo) {
        const selectedActivity = activityListData.find(
          (activity) => activity.value === props.slotInfo.timeLogActivityId
        );
        setSelectActivity(selectedActivity || null);
      }
      if (props.isModelOpen && activityListData) {
        const defaultActivity = activityListData?.find(
          (activity) => activity.value === 1
        );
        if (defaultActivity) {
          setSelectActivity(defaultActivity);
          handalactivity(defaultActivity);
        }
      }
    }
  }, [
    isActivityFetching,
    isActivityFetched,
    timeLogActivityData,
    props.slotInfo,
    props.isModelOpen,
  ]);

  //   Sub Activity Dropdown
  useEffect(() => {
    if (
      !isSubActivityFetching &&
      isSubActivityFetched &&
      timeLogSubActivityData
    ) {
      const subActivityListData = timeLogSubActivityData.map((item) => ({
        value: item.timeLogSubActivityId,
        label: item.subActivityName,
      }));
      setSubActivityList(subActivityListData);
      if (props.slotInfo) {
        const selectedSubActivity = subActivityListData.find(
          (subActivity) =>
            subActivity.value === props.slotInfo.timeLogSubActivityId
        );
        setSelectSubActivity(selectedSubActivity || null);
      }
    }
  }, [
    isSubActivityFetching,
    isSubActivityFetched,
    timeLogSubActivityData,
    props.slotInfo,
  ]);

  const handleDateChange = (date) => {
    setWorkAtData(date);
  };
  const handaltextarea = (data) => {
    setDesciptionData(data.target.value);
  };

  const handlestarttimeDateChange = (data) => {
    setStartTimeData(data);
  };
  const handleEndDateTimeChange = (data) => {
    setEndTimeData(data);
  };

  const calculateTotalTime = () => {
    if (startTimeData && endTimeData) {
      const start = new Date(startTimeData);
      const end = new Date(endTimeData);

      let timeDifference = end - start;

      if (timeDifference < 0) {
        const fullDayInMs = 24 * 60 * 60 * 1000;
        timeDifference += fullDayInMs;
      }

      // Set the total time
      setTotalTime(formatTimeDifference(timeDifference));
    }
  };

  const formatTimeDifference = (differenceInMs) => {
    const totalMinutes = Math.floor(differenceInMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
  };

  useEffect(() => {
    calculateTotalTime();
  }, [startTimeData, endTimeData]);

  const filterPassedDate = (date) => {
    if (!workAtData) return true;
    const currentDate = new Date();
    const selectedDate = new Date(date);
    return selectedDate.getTime() <= currentDate.getTime();
  };

  useEffect(() => {
    if (isTimeSheetRecordAdded && addTimeSheetRecordData) {
      if (addTimeSheetRecordData?.errorMessage?.includes("exists")) {
        ToastService.error(addTimeSheetRecordData.errorMessage);
        return;
      } else {
        ToastService.success(addTimeSheetRecordData.errorMessage);
        if (props.onSuccess) {
          props.onSuccess();
          handleCloseClick();
        }
        if (props.isModelOpen) {
          handleCloseClick();
        }
      }
    }
  }, [isTimeSheetRecordAdded, addTimeSheetRecordData]);

  return (
    <>
      <div className="task-container">
        <div className="row justify-content-between">
          <div className="col-6 validation-left-0">
            <Label labelName="Activity" isRequired={true} />
            <DropdownSelect
              optionsValue={activityList}
              placeholder={"Select Activity"}
              value={selectActivity}
              handleDropdownChange={handalactivity}
            />
          </div>

          <div className="col-6 validation-left-0">
            <Label labelName="Sub Activity" isRequired={true} />
            <DropdownSelect
              optionsValue={subActivityList}
              placeholder={"Select Sub Activity"}
              value={selectSubActivity}
              handleDropdownChange={(option) => setSelectSubActivity(option)}
            />
          </div>
          {(selectActivity?.value === 1 || selectActivity?.value === 6) && (
            <>
              <div className="col-6 validation-left-0 mt-1">
                <Label labelName="Project" isRequired={true} />
                <DropdownSelect
                  optionsValue={projectList}
                  placeholder={"Select Project"}
                  value={selectProject}
                  handleDropdownChange={handalprojectchange}
                />
              </div>
            </>
          )}
          {selectActivity?.value === 1 && (
            <>
              <div className="col-6 validation-left-0 mt-1">
                <Label labelName="Task" isRequired={true} />
                <DropdownSelect
                  optionsValue={taskList}
                  placeholder={"Select Task"}
                  value={selectTask}
                  handleDropdownChange={(options) => setSelectTask(options)}
                />
              </div>
            </>
          )}
          <div className="col-3 validation-left-0 mt-1">
            <Label labelName="Total Time" isRequired={true} />
            <div className="time-container">
              <Iconify icon="lucide:timer" width={30} />
              <Input
                placeholder={"Total Time"}
                value={totalTime}
                isReadOnly="true"
              />
            </div>
          </div>
          <div className="time-range">
            <div className="time-box validation-left-0 mt-1 no-icon">
              <Label labelName="Star Time" isRequired={true} />
              <DatePickerComponent
                isDisable={false}
                selected={startTimeData}
                onChange={handlestarttimeDateChange}
                placeholder={"Start Time"}
                datePickerConfig={{
                  timeInputLabel: "Time:",
                  displayTimeSelect: true,
                  timeFormat: "p",
                  timeIntervals: 15,
                  displayTimeSelectOnly: true,
                  format: "h:mm aa",
                }}
              />
            </div>
            <div className="time-range-badge">
              <Label labelName="-" isRequired={false} />
            </div>
            <div className="time-box validation-left-0 mt-1  no-icon">
              <Label labelName="End Time" isRequired={true} />
              <DatePickerComponent
                isDisable={false}
                selected={endTimeData}
                onChange={handleEndDateTimeChange}
                placeholder={"End Time"}
                datePickerConfig={{
                  filteredTime: filterPassedTime,
                  timeInputLabel: "Time:",
                  displayTimeSelect: true,
                  timeFormat: "p",
                  timeIntervals: 15,
                  displayTimeSelectOnly: true,
                  format: "h:mm aa",
                }}
              />
            </div>
          </div>

          <div className="date-picker-box validation-left-0 mt-1">
            <Label labelName="Work Date" isRequired={true} />
            <DatePickerComponent
              isDisable={false}
              selected={
                new Date(workAtData)
                // props?.slotInfo?.timesheetDetailId && props?.slotInfo?.timesheetDetailId !== 0
                //   ? new Date(workAtData)
                //   : new Date(props.setDate)
              }
              onChange={handleDateChange}
              placeholder={"Enter Work Start Time"}
              datePickerConfig={{
                filteredDate: filterPassedDate,
                timeInputLabel: "Enter Work Start Time:",
                timeFormat: "p",
                timeIntervals: 15,
                format: "dd/MM/yyyy",
              }}
            />
          </div>
          <div className="col-12 validation-left-0 mt-1 textarea">
            <Label labelName="Description" isRequired={true} />
            <TextArea
              placeholder="Enter Description"
              textareaRows={3}
              maxLength={200}
              value={desciptionData}
              onChange={handaltextarea}
            />
          </div>
          <div></div>
        </div>
      </div>
      <div className="col-12 d-flex justify-content-end mt-4 button-submit">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={handleCloseClick}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn  ml-4"
          buttonText={props.slotInfo ? "Update" : "Add"}
          onClick={handleSaveClick}
          isLoading={isTimeSheetRecordAdding}
        />
      </div>
    </>
  );
};

export default TimeLogPopup;
